import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
const BACKEND_BASE_URL = process.env.REACT_APP_API_URL 
  ? process.env.REACT_APP_API_URL.replace('/api', '') 
  : 'http://localhost:5000';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

/**
 * Convert local image path to full URL
 * @param {string} imagePath - Local image path (e.g., /uploads/images/abc.png)
 * @returns {string} - Full image URL
 */
export const getImageUrl = (imagePath) => {
  if (!imagePath) return null;
  
  // If already a full URL, return as is
  if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
    return imagePath;
  }
  
  // Remove leading slash if present
  const path = imagePath.startsWith('/') ? imagePath : `/${imagePath}`;
  return `${BACKEND_BASE_URL}${path}`;
};

/**
 * Get all saved content (only visible), ordered by layout section/sortOrder
 */
export const getAllSavedContent = async () => {
  const response = await api.get('/content?onlyVisible=true&limit=200');
  return response.data;
};

/**
 * Get visible content filtered by category
 */
export const getContentByCategory = async (category) => {
  const response = await api.get(`/content?onlyVisible=true&limit=200&category=${encodeURIComponent(category)}`);
  return response.data;
};

/**
 * Get single content by ID
 */
export const getContentById = async (id) => {
  const response = await api.get(`/content/${id}`);
  return response.data;
};

/**
 * Get single content by its title slug (for clean URLs without a numeric ID)
 */
export const getContentBySlug = async (slug) => {
  const response = await api.get(`/content/by-slug/${encodeURIComponent(slug)}`);
  return response.data;
};

export default api;
